import React from 'react';
import { Touchable, type TouchableProps } from './Touchable';

export type DashedSecondaryButtonProps = Omit<TouchableProps, 'haptic'>;

const BASE =
  'w-full h-11 bg-transparent text-ink-muted rounded-2xl font-bold text-xs active:scale-[0.98] active:bg-soft transition-all border-2 border-dashed border-line uppercase tracking-widest';

export const DashedSecondaryButton: React.FC<DashedSecondaryButtonProps> = ({
  className,
  ...rest
}) => (
  <Touchable haptic="boundary" className={className ? `${BASE} ${className}` : BASE} {...rest} />
);
